import Split from "./Split.jsx";

function Home(){
    return (
        <>
        <div>
        {/* <h2>Home Page</h2> */}
        <Split/>
        </div>
        </>
    )
}

export default Home;
